import { verificationService } from "../../../../../shared/services/verificaiton";
import { NotificationTemplate } from "../index";

export const BankingUpdateRequired: NotificationTemplate<undefined> = {
  renderTitle: props => props.subject,
  renderBody: props => props.message,
  buttonActionAsync: (_, history) => async () => {
    await verificationService.completeBankingVerification(history);
  },
  buttonText: () => "Complete verification"
};
